import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// GUARDAR PACAS
export const postGuardarPacas = async (data) => {
  const result = await PrivateInterceptor(
    "Suministros/ArchivoPacas/postGuardarPacas",
    "POST",
    { Datos: data },
  );
  return result;
};

export const UpdateGuardarPacas = async (data) => {
  const result = await PrivateInterceptor(
    "Suministros/ArchivoPacas/UpdateGuardarPacas",
    "POST",
    { Datos: data },
  );
  return result;
};

export const DeletePacas = async (data) => {
  const result = await PrivateInterceptor(
    "Suministros/ArchivoPacas/DeletePacas",
    "POST",
    { Datos: data },
  );
  return result;
};

export const getCodigoBale = async (Ginbale) => {
  const result = await PrivateInterceptor(
    `Suministros/ArchivoPacas/CodigoBale/${Ginbale}`,
    "GET",
  );
  return result;
};

export const getPacas = async (IdIngresoDetalle) => {
  const result = await PrivateInterceptor(
    `Suministros/ArchivoPacas/getPacas/${IdIngresoDetalle}`,
    "GET",
  );
  return result;
};
